import MDinput from '@/components/MDinput';
import Select from '@/components/DSE/Select';
import InputNumber from '@/components/DSE/InputNumber';

import { validatorRequire, validatorRequireNumber } from '@/utils/validators';
import { OrderLineStatusOption } from '@/utils/constants';
import Switch from '@/components/DSE/Switch';

export function getFormDefinition(vue) {
  return {
    code: {
      type: InputNumber,
      defaultValue: 1,
      props: {
        min: 1,
        step: 1
      },
      dynamicProps: form => ({
        disabled: form.reservedYN
      }),
      rules: [{ validator: validatorRequireNumber }]
    },
    orderLineStatusOption: {
      type: Select,
      defaultValue: OrderLineStatusOption.New,
      props: {
        caption: 'orderLineStatus.orderLineStatus',
        valueField: 'code',
        labelField: 'description',
        loading: vue.$store.getters['option/isLoading'],
        options: vue.$store.getters['option/loadedOptions']('orderLineStatus')
      },
      dynamicProps: form => ({
        disabled: form.reservedYN
      }),
      rules: [{ validator: validatorRequireNumber }]
    },
    name: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'orderLineStatus.orderLineSubstatus',
        maxlength: 64,
        required: true
      },
      dynamicProps: form => ({
        disabled: form.reservedYN
      }),
      rules: [{ validator: validatorRequire }]
    },
    substatusOrder: {
      type: InputNumber,
      defaultValue: 0,
      props: {
        min: 1,
        step: 1,
        caption: 'orderLineStatus.substatusOrder'
      },
      dynamicRules: form => [{ validator: validateSubstatusOrder(vue, form) }]
    },
    scanParameter: {
      type: MDinput,
      defaultValue: '',
      props: {
        caption: 'orderLineStatus.scanParameter',
        maxlength: 64
      },
      dynamicProps: form => ({
        disabled: form.reservedYN
      })
    },
    cancellationAllowedYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'orderLineStatus.cancellationAllowed',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    changableYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'orderLineStatus.changable',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    settableYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'orderLineStatus.settable',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    canBeRemovedFromSeriesYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'orderLineStatus.removeFromSeries',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    },
    feedBackYN: {
      type: Switch,
      defaultValue: false,
      props: {
        caption: 'orderLineStatus.feedBack',
        activeText: 'common.yes',
        inactiveText: 'common.no'
      }
    }
  };
}

const validateSubstatusOrder = (vue, form) => (rule, value, callback) => {
  if (value <= 3 && !form.reservedYN) {
    callback(new Error(vue.$i18n.t('orderLineStatus.substatusOrderReserved')));
  } else {
    callback();
  }
};

export default getFormDefinition;

export function createItemFromFormData(vue, form) {
  return form;
}

export function createFormDataFromItem(vue, item) {
  const form = {
    ...item
  };
  return form;
}
